module.exports = __webpack_public_path__ + "static/media/preOrderSteps.2083495e.png";